/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type CustomPlatformEmailType =
  typeof CustomPlatformEmailType[keyof typeof CustomPlatformEmailType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomPlatformEmailType = {
  KYC_DOCUMENTS_REQUEST: 'KYC_DOCUMENTS_REQUEST',
} as const;
